var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.currentActions),function(currentAction,i){return _c('v-list-item',{key:i,on:{"click":function($event){return _vm.changeComponent(currentAction[2])}}},[_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(currentAction[1])}})],1),_c('v-list-item-title',{domProps:{"textContent":_vm._s(currentAction[0])}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }